import React from 'react';
import { RouteObject } from 'react-router-dom';
import { dossiersBasePath } from '@europrocurement/l2d-modules';
import {
    addFormalityPath,
    listeDossiersPath,
    detailDossierPath,
    dossierValidationPath,
} from './constants';
import { DossierRoot, AddFormality, DetailDossier, InfoValidation, ListeDossiers } from './views';

export const DossierRouter: RouteObject = {
    path: dossiersBasePath,
    element: <DossierRoot />,
    handle: { title: 'Dossiers' },
    children: [
        {
            path: listeDossiersPath,
            element: <ListeDossiers />,
            handle: { title: 'Dossiers - Liste' },
        },
        {
            path: detailDossierPath,
            element: <DetailDossier />,
            handle: { title: 'Dossiers - Détails' },
        },
        {
            path: dossierValidationPath,
            element: <InfoValidation />,
            handle: { title: 'Dossiers - Validation' },
        },
        {
            path: addFormalityPath,
            element: <AddFormality />,
            handle: { title: 'Dossiers - Création' },
        },
    ],
};
